import React from "react";
import { NavLink } from "react-router-dom";
import { kp } from "../karkhanaPaths";

type Props = { reviewCount?: number };

/** Tabs shared by the worker screens. */
const WorkersNav = ({ reviewCount }: Props) => (
  <nav className="kw-tabs" aria-label="Worker screens">
    <NavLink exact to={kp.workers()} className="kw-tab" activeClassName="is-active">
      Workers
    </NavLink>
    <NavLink to={kp.workerReview()} className="kw-tab" activeClassName="is-active">
      To review
      {reviewCount ? <span className="kw-tab__count">{reviewCount}</span> : null}
    </NavLink>
    <NavLink to={kp.workerImport()} className="kw-tab" activeClassName="is-active">
      Import
    </NavLink>
    <NavLink to={kp.codes()} className="kw-tab" activeClassName="is-active">
      Categories &amp; codes
    </NavLink>
  </nav>
);

export default WorkersNav;
